import { Link } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

export default function ComingSoon() {
    return (
        <div className="bg-paper min-h-screen flex flex-col">
            <Navbar />
            <div className="flex-1 max-w-3xl mx-auto px-6 py-32 text-center">
                <p className="eyebrow mb-4">GEOGRAPHY</p>
                <h1 className="h1 mb-6" data-testid="coming-soon-headline">Coming soon to your country.</h1>
                <p className="text-ink-600 leading-relaxed max-w-xl mx-auto">
                    SocietyIntent is currently live in the <span className="font-semibold">United States</span> and{" "}
                    <span className="font-semibold">Canada</span>. We&apos;re expanding carefully — TCPA, CASL, and local
                    payout laws differ by country and we want to do this right.
                </p>
                <div className="mt-10">
                    <Link to="/" className="btn btn-outline" data-testid="back-home-btn">Back to home</Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}
